import { render, staticRenderFns } from "./billing-records-table.vue?vue&type=template&id=6d4d2026&scoped=true&"
import script from "./billing-records-table.vue?vue&type=script&lang=js&"
export * from "./billing-records-table.vue?vue&type=script&lang=js&"
import style0 from "./billing-records-table.vue?vue&type=style&index=0&id=6d4d2026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d2026",
  null
  
)

export default component.exports